import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { TField } from '@r1-frontend/ui-react/organisms/Forms/NamePhoneForm';
import { IAction } from '@r1-frontend/shared/types/Redux';

const fillPhone = ({ value, isValid }: Omit<TField, 'clearInput'>): IAction<BP42Action.FillPhone, { value: string, isValid: boolean }> => ({
    type: BP42Action.FillPhone,
    payload: {
        value,
        isValid,
    },
});

export default fillPhone;
